import React, { Fragment } from 'react';
import 'styling/semantic.less';
import 'styling/global';
import 'utilities/i18n';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Login from './routes/public/Login';
import PasswordReset from './routes/public/PasswordReset';
import SetPassword from './routes/public/SetPassword';
import AuthCode from './routes/public/AuthCode';
import AuthCode2 from './routes/public/AuthCode2';
import MainApp from './routes/MainApp';
import { inject, observer } from 'mobx-react';
import ModalMessage from 'components/ModalMessage';
import { toJS } from 'mobx';

console.info('NODE_ENV=', process.env.NODE_ENV);
console.info('BABEL_ENV=', process.env.BABEL_ENV);

@withRouter
@inject(root => ({ uiShared: root.uiShared }))
@observer
export default class App extends React.Component {
	constructor(props) {
		super(props);
		const { href } = window.location;
		if (href.indexOf('/authCode?') > -1 && href.indexOf('/#/authCode?') === -1) {
			window.location.href = href.replace('/authCode?', '/#/authCode?');
		}
		if (href.indexOf('/authCode2?') > -1 && href.indexOf('/#/authCode2?') === -1) {
			window.location.href = href.replace('/authCode2?', '/#/authCode2?');
		}
	}

	render() {
		const { uiShared } = this.props;
		return (
			<Fragment>
				<Switch>
					<Route path="/login" component={Login} />
					<Route path="/password-reset" component={PasswordReset} />
					<Route path="/set-password" component={SetPassword} />
					<Route path="/authCode" component={AuthCode} />
					<Route path="/authCode2" component={AuthCode2} />
					<AppRoute path="/app" component={MainApp} />
					<Redirect to="/app" />
				</Switch>
				<ModalMessage
					message={uiShared.modal.message}
					open={uiShared.modal.isActive}
					showLoader={uiShared.modal.showLoader}
					closeIcon={uiShared.modal.closeIcon}
					size={uiShared.modal.size}
					onClose={uiShared.modal.onClose}
					header={uiShared.modal.header}
					actions={toJS(uiShared.modal.actions)}
					config={uiShared.modal.config}
				/>
			</Fragment>
		);
	}
}

const AppRoute = withRouter(
	inject(root => ({
		auth: root.auth,
		uiShared: root.uiShared
	}))(
		observer(({ component: Component, auth, uiShared, ...rest }) => {
			const { href } = window.location;
			let isProcessing = false;
			if (
				(href.indexOf('/authCode?') > -1 && href.indexOf('/#/authCode?') === -1) ||
				(href.indexOf('/authCode2?') > -1 && href.indexOf('/#/authCode2?') === -1)
			) {
				isProcessing = true;
			}
			if (!auth.isAuthenticated && !isProcessing) {
				return <Redirect to="/login" />;
			}

			return <Route {...rest} render={props => <Component {...props} />} />;
		})
	)
);



// WEBPACK FOOTER //
// ./src/App.js